// @ts-check

const keepAwakeVideoSource =
  "data:video/mp4;base64,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";

/** @type {WakeLockSentinel | null} */
let wakeLock = null;
/** @type {Promise<void> | null} */
let wakeLockRequestPromise = null;
/** @type {HTMLVideoElement | null} */
let keepAwakeVideo = null;
let shouldKeepAwake = false;

/**
 * @returns {() => void}
 */
export function bindWakeLockLifecycle() {
  document.addEventListener("visibilitychange", refreshWakeLock);
  window.addEventListener("pageshow", enableWakeLock);
  window.addEventListener("focus", enableWakeLock);
  window.addEventListener("pagehide", disableWakeLock);
  window.addEventListener("beforeunload", disableWakeLock);
  document.addEventListener("pointerdown", enableWakeLock);
  document.addEventListener("click", enableWakeLock);
  document.addEventListener("keydown", enableWakeLock);
  enableWakeLock();

  return function cleanupWakeLockLifecycle() {
    document.removeEventListener("visibilitychange", refreshWakeLock);
    window.removeEventListener("pageshow", enableWakeLock);
    window.removeEventListener("focus", enableWakeLock);
    window.removeEventListener("pagehide", disableWakeLock);
    window.removeEventListener("beforeunload", disableWakeLock);
    document.removeEventListener("pointerdown", enableWakeLock);
    document.removeEventListener("click", enableWakeLock);
    document.removeEventListener("keydown", enableWakeLock);
    disableWakeLock();
  };
}

export function enableWakeLock() {
  shouldKeepAwake = true;
  void requestWakeLock();
}

export function disableWakeLock() {
  shouldKeepAwake = false;
  void releaseWakeLock();
}

/**
 * @returns {Promise<{ permission: string, requested: boolean, nativeActive: boolean, requestPending: boolean, videoFallback: string }>}
 */
export async function getWakeLockDebugState() {
  const permission = await getWakeLockPermissionState();
  return {
    permission,
    requested: shouldKeepAwake,
    nativeActive: hasActiveWakeLock(),
    requestPending: wakeLockRequestPromise !== null,
    videoFallback: getVideoWakeFallbackState(),
  };
}

/**
 * @returns {HTMLVideoElement}
 */
function createKeepAwakeVideo() {
  if (keepAwakeVideo) {
    return keepAwakeVideo;
  }

  const videoElement = document.createElement("video");
  videoElement.setAttribute("aria-hidden", "true");
  videoElement.setAttribute("playsinline", "");
  videoElement.muted = true;
  videoElement.loop = true;
  videoElement.preload = "auto";
  videoElement.style.position = "fixed";
  videoElement.style.width = "1px";
  videoElement.style.height = "1px";
  videoElement.style.opacity = "0";
  videoElement.style.pointerEvents = "none";
  videoElement.style.top = "0";
  videoElement.style.left = "0";
  videoElement.src = keepAwakeVideoSource;
  document.body.appendChild(videoElement);
  keepAwakeVideo = videoElement;
  return keepAwakeVideo;
}

/**
 * @returns {boolean}
 */
function hasActiveWakeLock() {
  let result = false;

  if (wakeLock && !wakeLock.released) {
    result = true;
  }

  return result;
}

/**
 * @param {HTMLVideoElement | null} videoElement
 * @returns {void}
 */
function releaseVideoWakeFallback(videoElement = keepAwakeVideo) {
  if (keepAwakeVideo === videoElement) {
    keepAwakeVideo = null;
  }

  if (!videoElement) {
    return;
  }

  videoElement.pause();
  videoElement.removeAttribute("src");
  videoElement.load();
  videoElement.remove();
}

/**
 * @returns {Promise<boolean>}
 */
async function requestVideoWakeFallback() {
  const videoElement = createKeepAwakeVideo();
  let result = false;

  if (!videoElement.paused) {
    result = true;
    return result;
  }

  try {
    await videoElement.play();
    if (!shouldKeepAwake || document.visibilityState !== "visible") {
      releaseVideoWakeFallback(videoElement);
      return result;
    }

    console.log("Wake lock active: hidden video fallback");
    result = true;
  } catch (error) {
    console.log(
      "Wake lock pending: hidden video fallback needs a user gesture",
      error,
    );
  }

  return result;
}

/**
 * @param {WakeLockSentinel} releasedWakeLock
 * @returns {void}
 */
function handleNativeWakeLockRelease(releasedWakeLock) {
  if (wakeLock !== releasedWakeLock) {
    return;
  }

  wakeLock = null;

  if (!shouldKeepAwake || document.visibilityState !== "visible") {
    return;
  }

  // Let the release event settle before requesting a replacement lock.
  window.setTimeout(function retryWakeLock() {
    void requestWakeLock();
  }, 0);
}

/**
 * @returns {Promise<boolean>}
 */
async function requestNativeWakeLock() {
  let result = false;

  if (!("wakeLock" in navigator)) {
    return result;
  }

  try {
    const nextWakeLock = await navigator.wakeLock.request("screen");
    if (!shouldKeepAwake || document.visibilityState !== "visible") {
      await nextWakeLock.release();
      return result;
    }

    wakeLock = nextWakeLock;
    wakeLock.addEventListener("release", function handleRelease() {
      handleNativeWakeLockRelease(nextWakeLock);
    });
    console.log("Wake lock active: native Screen Wake Lock API");
    result = true;
  } catch (error) {
    wakeLock = null;
    console.log(
      "Wake lock unavailable: native request failed, using fallback",
      error,
    );
  }

  return result;
}

async function requestWakeLock() {
  if (wakeLockRequestPromise) {
    await wakeLockRequestPromise;
    return;
  }

  wakeLockRequestPromise = requestWakeLockOnce();

  try {
    await wakeLockRequestPromise;
  } finally {
    wakeLockRequestPromise = null;
  }
}

async function requestWakeLockOnce() {
  if (!shouldKeepAwake || document.visibilityState !== "visible") {
    return;
  }

  if (hasActiveWakeLock()) {
    return;
  }

  const nativeWakeLockActive = await requestNativeWakeLock();
  if (nativeWakeLockActive) {
    releaseVideoWakeFallback(keepAwakeVideo);
    return;
  }

  if (!shouldKeepAwake || document.visibilityState !== "visible") {
    return;
  }

  await requestVideoWakeFallback();
}

function refreshWakeLock() {
  if (document.visibilityState !== "visible") {
    disableWakeLock();
    return;
  }

  enableWakeLock();
}

async function releaseWakeLock() {
  const activeWakeLock = wakeLock;
  const activeKeepAwakeVideo = keepAwakeVideo;
  wakeLock = null;

  if (activeWakeLock && !activeWakeLock.released) {
    try {
      await activeWakeLock.release();
    } catch (error) {
      console.debug("[timer] wake lock was already released", error);
    }
  }

  if (!shouldKeepAwake) {
    releaseVideoWakeFallback(activeKeepAwakeVideo);
  }
}

/**
 * @returns {Promise<string>}
 */
async function getWakeLockPermissionState() {
  let result = "(unsupported)";

  if (!("permissions" in navigator)) {
    return result;
  }

  try {
    const descriptor = /** @type {PermissionDescriptor} */ (
      /** @type {unknown} */ ({ name: "screen-wake-lock" })
    );
    const permissionStatus = await navigator.permissions.query(descriptor);
    result = permissionStatus.state;
  } catch (error) {
    result = `(query failed: ${getErrorMessage(error)})`;
  }

  return result;
}

/**
 * @returns {string}
 */
function getVideoWakeFallbackState() {
  let result = "(not created)";

  if (keepAwakeVideo) {
    result = keepAwakeVideo.paused ? "paused" : "playing";
  }

  return result;
}

/**
 * @param {unknown} error
 * @returns {string}
 */
function getErrorMessage(error) {
  let message = String(error);

  if (error instanceof Error) {
    message = error.message;
  }

  return message;
}
